import { combineEpics } from 'redux-observable';
import { epics as globalSettingsEpics } from './globalSettings';
import { epics as carFilterEpics } from './carFilter';
import { epics as carsEpics } from './cars';
import { epics as documentsEpics } from './documents';
import { epics as userEpics } from './user';
import { epics as articlesEpics } from './articles';
import { epics as localArticlesEpics } from './localArticles';
import { epics as myNafEpics } from './myNaf';
import { epics as sitestructureEpics } from './sitestructure';
import { epics as becomeAMemberEpics } from './becomeAMember';
import { epics as myMembershipEpics } from './myMembership';
import { epics as myInvoicesEpics } from './myInvoices';
import { epics as orderEpics } from './order';
import { epics as loggedInActivationOrderEpics } from './loggedInActivationOrder';
import { epics as householdMembersEpics } from './householdMembers';
import { epics as myVehiclesEpics } from './myVehicles';
import { epics as myMessagesEpics } from './myMessages';
import { epics as benefitsEpics } from './benefits';
import { epics as internationalDrivingPermitEpics } from './internationalDrivingPermit';
import { epics as idpCountriesEpics } from './idpCountries';
import { epics as frontPageEpics } from './frontPage';
import { epics as centersEpics } from './centers';
import { epics as centerProductsEpics } from './centerProducts';
import { epics as nafLocationEpics } from './nafLocation';
import { epics as nafEventsEpics } from './nafEvents';
import { epics as faqEpics } from './faq';
import { epics as routePlannerEpics } from './routePlanner';
import { epics as internalSiteSearchEpics } from './internalSiteSearch';
import { epics as myProfileEpics } from './myProfile';
import { epics as productsEpics } from './products';
import { epics as consumerGuidesEpics } from './consumerGuides';
import { TypedEpic } from './types';

// Every epics file must be listed here, in redux/index.ts module order (test/__tests__/client/redux/epics/registry.test.ts).
export const allEpics: TypedEpic[] = [
  ...globalSettingsEpics,
  ...carFilterEpics,
  ...carsEpics,
  ...documentsEpics,
  ...userEpics,
  ...articlesEpics,
  ...localArticlesEpics,
  ...myNafEpics,
  ...sitestructureEpics,
  ...becomeAMemberEpics,
  ...myMembershipEpics,
  ...myInvoicesEpics,
  ...orderEpics,
  ...loggedInActivationOrderEpics,
  ...householdMembersEpics,
  ...myVehiclesEpics,
  ...myMessagesEpics,
  ...benefitsEpics,
  ...internationalDrivingPermitEpics,
  ...idpCountriesEpics,
  ...frontPageEpics,
  ...centersEpics,
  ...centerProductsEpics,
  ...nafLocationEpics,
  ...nafEventsEpics,
  ...faqEpics,
  ...routePlannerEpics,
  ...internalSiteSearchEpics,
  ...myProfileEpics,
  ...productsEpics,
  ...consumerGuidesEpics,
];

export const rootEpic = combineEpics(...allEpics);
